import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Flex,
  Text,
  Tag,
  Button,
  Heading,
  Stack,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Skeleton,
  SkeletonText,
  useToast,
  useDisclosure
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Paginate from "components/navigation/Paginate.js";
import TextFilter from "components/filter/TextFilter";
import Card from "components/card/Card.js";
import { checkprivileges } from "helpers/utils";
import { SearchAdminGroup, GetAdminGroups, DeleteAdminGroup } from "services/adminGroupService";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FiArrowLeft, FiEye } from "react-icons/fi";
import { FaPlus } from "react-icons/fa";

import { MdDelete, MdEditNote } from "react-icons/md";

export default function Index() {
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isPartnerDrawerOpen, onOpen: onPartnerDrawerOpen, onClose: onPartnerDrawerClose } = useDisclosure();

  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;
  const privileges = userState.hasOwnProperty("privileges") ? userState.privileges : [];
  const [loading, setLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [sortOrder, setSortOrder] = useState("desc");
  const [from, setFrom] = useState(0);
  const [limit, setLimit] = useState(200);
  const [orderBy, setOrderBy] = useState("createdAt");
  const [organization, setOrganization] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [organizationId, setOrganizationId] = useState("");

  const getOrganizations = async () => {
    try {
      setLoading(true);
      const pagination = {
        from: from,
        limit: limit,
        orderBy: orderBy,
        sortOrder: sortOrder,
      };
      const filter = {
        deleted: false
      };
      const response = await GetAdminGroups(pagination, filter, token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setPageCount(response.data.count / limit);
        setOrganizations(response?.data?.adminGroups);
        setLoading(false);
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  const deleteOrganization = async () => {
    try {
      setLoading(true);
      const response = await DeleteAdminGroup(organizationId, token);
      setLoading(false);
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setLoading(false);
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setLoading(false);
        return;
      }
      if (response.success) {
        toast({
          title: response.message || "Organization deleted successfully",
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        getOrganizations();
        onClose();
      }
    } catch (error) {
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      const searchData = {
        deleted: false,
        type: "admin",
        searchText
      };
      setLoading(true);
      const response = await SearchAdminGroup(searchData, token);
      setLoading(false);
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setOrganizations(response.data);
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    !checkprivileges(privileges, ["Manage Organizations", "Admin"]) && (toast({ title: "You are not allowed", status: "error", duration: 9000, position: "top-right", isClosable: true, }) && navigate("/admin/dashboard"));
    getOrganizations();
  }, []);

  return (
    <>
      <Drawer isOpen={isPartnerDrawerOpen} placement="right" onClose={onPartnerDrawerClose} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader color="#45005E">Partner Details</DrawerHeader>
          <DrawerBody>
            <Box>
              <Flex gap="2">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Partner Name</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.adminGroupName}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Partner Address</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.adminGroupAddress}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Phone</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.phone}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Email</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.email}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">City</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.city}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">State</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.state}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Test Key</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.testApiKey}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Production Key</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.productionApiKey}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Production Key</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>{organization && organization.productionApiKey}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Query Commission</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>NGN {organization && organization.queryCommission}</Text>
              </Flex>

              <Flex gap="2" mt="4">
                <Tag fontSize={{ sm: "md", md: "lg" }} background="brand.500" color="white" fontWeight="bold">Download Commission</Tag>
                <Text fontSize={{ sm: "md", md: "lg" }}>NGN {organization && organization.downloadCommission}</Text>
              </Flex>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={isOpen} onClose={onClose} size={"md"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Icon
              as={FiArrowLeft}
              onClick={onClose}
              width="20px"
              height="20px"
            />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SimpleGrid>
              <Box textAlign="center">
                <Heading
                  fontSize={{ base: "md", sm: "lg", md: "lg", lg: "xl" }}
                >
                  Are you sure you want to delete this?
                </Heading>
              </Box>
            </SimpleGrid>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              No
            </Button>
            <Button
              variant="primary"
              background="#000000"
              isLoading={loading}
              loadingText="Please Wait"
              onClick={(e) => {
                e.preventDefault();
                deleteOrganization();
              }}
            >
              Proceed
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Box mt={{ sm: "40px", md: "80px" }} width="100%" mb="70">
        <Text
          color={"black"}
          mb="4px"
          fontFamily={"ManropeSemiBold"}
          fontSize={{ base: "md", sm: "lg", md: "xl", lg: "2xl" }}> Partners
        </Text>
      </Box>

      <SimpleGrid
        columns={{ sm: 1, md: 2 }}
        w="100%"
        p="2"
        spacing="2"
        mb="4"
      >
        <Box mb="5">
          <Button
            variant="brand"
            width="120px"
            onClick={() => {
              navigate("/admin/organizations/addorganization");
            }}
          >
            <Icon as={FaPlus} width="16px" height="16px" />&nbsp; Add Partner
          </Button>
        </Box>
        <Box width="100%" textAlign="right">
          <TextFilter
            searchText={searchText}
            setSearchText={setSearchText}
            searchTextLabel="Search By Partner Name"
            handleSearch={handleSearch}
          />
        </Box>
      </SimpleGrid>


      {loading ? (
        <LoadingOrganizations />
      ) : (
        <TableContainer>
          <Table variant="striped" fontSize={{ sm: "md", md: "lg" }}>
            <Thead>
              <Tr>
                <Th color="#000000">Name</Th>
                <Th color="#000000">Email</Th>
                <Th color="#000000">Phone</Th>
                {privileges.includes("Admin") &&
                  <Th color="#000000">Action</Th>
                }
              </Tr>
            </Thead>
            <Tbody>
              {organizations &&
                organizations.map((organization) => (
                  <Tr>
                    <Td>{organization.adminGroupName} </Td>
                    <Td>{organization.email}</Td>
                    <Td>{organization.phone}</Td>
                    {privileges.includes("Admin") &&
                      <Td>
                        {" "}
                        <Menu>
                          <MenuButton
                            as={Button}
                            width="100px"
                            variant="brand"
                            rightIcon={<ChevronDownIcon />}
                          >
                            Action
                          </MenuButton>
                          <MenuList>
                            <MenuItem
                              onClick={() => {
                                navigate("/admin/organizations/addorganization/" + organization._id, {
                                  state: { organizationId: organization._id },
                                });
                              }}
                            >
                              <Icon
                                as={MdEditNote}
                                width="20px"
                                height="20px"
                                color="black"
                              /> &nbsp; Edit &nbsp;{" "}
                              {" "}
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                setOrganizationId(organization._id);
                                onOpen();
                              }}
                            >
                              <Icon
                                as={MdDelete}
                                width="20px"
                                height="20px"
                                color="black"
                              /> &nbsp; Delete &nbsp;
                            </MenuItem>

                            <MenuItem
                              onClick={() => {
                                setOrganization(organization);
                                onPartnerDrawerOpen();
                              }}>
                              <Icon
                                as={FiEye}
                                width="20px"
                                height="20px"
                                color="black"
                              /> &nbsp; View &nbsp;
                            </MenuItem>

                          </MenuList>
                        </Menu>
                      </Td>
                    }
                  </Tr>
                ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
      {pageCount > 0 && (
        <Box width="100%" mt="5">
          <Paginate
            pageCount={pageCount}
            setFrom={setFrom}
            getRecords={getOrganizations}
          />
        </Box>
      )}
    </>
  );
};

const LoadingOrganizations = () => {
  return (
    <>
      <Card align="center" p="5px">
        <Stack>
          <Skeleton height="5px" />
          <SkeletonText mt="2" noOfLines={3} spacing="3" />
          <Skeleton height="5px" />
        </Stack>
      </Card>

      <Card align="center" p="5px" mt="5">
        <Stack>
          <Skeleton height="5px" />
          <SkeletonText mt="2" noOfLines={3} spacing="3" />
          <Skeleton height="5px" />
        </Stack>
      </Card>
    </>
  );
};